import React from 'react';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-259">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-260">
        <img src="https://images.unsplash.com/photo-1500595046743-cd271d694d30?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80" alt="GreenSlopes Farm Landscape" className="w-full h-full object-cover" data-id="element-261" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-green-900/80" data-id="element-262"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-263">
        <div className="mb-6 inline-block px-4 py-1.5 rounded-full border border-green-300/30 bg-green-900/30 backdrop-blur-sm" data-id="element-264">
          <span className="text-green-100 text-sm font-medium tracking-wider uppercase" data-id="element-265">
            Established 1960 • Nyandarua, Kenya
          </span>
        </div>
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight leading-tight" data-id="element-266">
          GreenSlopes <span className="text-green-400" data-id="element-267">Farm</span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-268">
          Excellence in dairy farming and sustainable agriculture. Nurturing the
          land and producing premium quality milk in the heart of the Rift
          Valley.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-269">
          <a href="#story" className="px-8 py-4 bg-green-600 hover:bg-green-500 text-white font-semibold rounded-lg transition-all shadow-lg hover:shadow-green-500/30 transform hover:-translate-y-1" data-id="element-270">
            Discover Our Story
          </a>
          <a href="#visits" className="px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/30 font-semibold rounded-lg transition-all" data-id="element-271">
            Book a Farm Visit
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce z-10" data-id="element-272">
        <a href="#about" className="text-white/70 hover:text-white transition-colors" data-id="element-273">
          <ChevronDown className="h-10 w-10" data-id="element-274" />
        </a>
      </div>
    </section>;
}